export enum ConfigurationOptionsEnum {
    Yes = 1,
    No = 2,
    CodeRequired = 3,
    CodeGenerated = 4,
    NfceYes = 5,
    NfceNo = 6,
    DebitCardYes = 7,
    DebitCardNo = 8,
    CreditCardYes = 9,
    CreditCardNo = 10,
    PixYes = 11,
    PixNo = 12,
    MoneyYes = 17,
    MoneyNo = 18
}